module.exports = __webpack_public_path__ + "img/downloadImg.b746f64a.png";